module.exports = __webpack_public_path__ + "static/gem-visa-card-933e4fadb2e3709c7b0fb74df036efda.png";